module.exports = __webpack_public_path__ + "static/media/9.da0a8f37.jpg";